export default __webpack_public_path__ + "static/media/a037-student-t3-s3-9.def49cc5.svg";